import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { CreateSampleDTO, CreateSampleResponseDTO } from "./type";

export async function createSample(
  sample: CreateSampleDTO,
): Promise<CreateSampleResponseDTO> {
  const response = await apiClient.post<CreateSampleResponseDTO>(
    apiPaths.samples.create,
    sample,
  );
  return response.data;
}
